module.exports = __webpack_public_path__ + "static/media/Case-managment.71bd4d44.png";